
(() => {
    window.addEventListener('load', () => {

      var swiper = new Swiper(".announcement-bar-slide", {
          spaceBetween: 0,
          autoplay: {
              delay: 4000,
              disableOnInteraction: false,
          },
      });


        let box = document.querySelector('body');
        let width = box.clientWidth;
        if (width > 768) {
            const element = document.querySelectorAll('[data-section-type="collection-carousel-template"] .carousel');
            for (let i = 0; i < element.length; i++) {
                const flickity = new Flickity(element[i], {
                    cellAlign: 'left',
                    groupCells: true,
                  
                    contain: true,
                    pageDots: false,
                });
            }
        }
        if (
            typeof document.querySelector('#product__review-desktop') !=
                'undefined' &&
            document.querySelector('#product__review-mobile') != null
        ) {
            if (width > 768) {
                document.querySelector('#product__review-mobile').remove();
            } else {
                document.querySelector('#product__review-desktop').remove();
            }
        }
        let productItem = document.querySelector('.grid-product__content');
        if (typeof productItem != 'undefined' && productItem != null) {
            let productItem_width = productItem.offsetWidth;
            let productItem_height = productItem.offsetHeight;
            document.documentElement.style.setProperty(
                '--product-item-height',
                productItem_height + 'px'
            );
            document.documentElement.style.setProperty(
                '--product-item-width',
                productItem_width + 'px'
            );
        }

        /* modal custom */
        const btnModals = document.querySelectorAll("[data-trigger='modal']");

        // Hàm xử lý bật, tắt modal thông qua class cung cấp
        function onActiveOrNot(buttonTargetModal, modal, open) {
            const html = document.querySelector('html');
            const modal_active =
                (modal && !modal.classList.contains('modal--active')) || null;
            if (modal_active && open) {
                modal.classList.add('modal--active');
                html.classList.add('js-drawer-open');
            } else {
                modal && modal.classList.remove('modal--active');
                html.classList.remove('js-drawer-open');
            }

            // đặt lại trạng thái cho nút button khi modal active | !active
            buttonTargetModal.setAttribute('aria-open', open);
        }

        // Dựa vào data-trigger='modal' truy xuất toàn bộ nút bật modal
        btnModals.forEach((btnModal) => {
            // lấy thông tin modal
            const modal = document.querySelector(
                btnModal.getAttribute('data-target')
            );

            // lấy trạng thái modal
            const open =
                btnModal.getAttribute('aria-open') === 'true' ? true : false;

            // Khởi động trạng thái mặc định của modal được set từ aria-open của button
            onActiveOrNot(btnModal, modal, open);

            // Bật modal thông qua button
            btnModal.addEventListener('click', () => {
                onActiveOrNot(btnModal, modal, !open);
            });

            // Tắt modal thông qua nút close
            modal &&
                modal
                    .querySelector('.modal__cancel')
                    .addEventListener('click', () => {
                        onActiveOrNot(btnModal, modal, !open);
                    });
        });

        const counters = document.querySelectorAll('.counter');
        counters.forEach((counter) => {
            counter.innerText = '0';
            const updateCounter = () => {
                const target = +counter.getAttribute('data-count');
                const count = +counter.innerText;
                const increment = target / 200;
                if (count < target) {
                    counter.innerText = `${Math.ceil(count + increment)}`;
                    setTimeout(updateCounter, 1);
                } else counter.innerText = target;
            };
            updateCounter();
        });

          if ( width < 768 ){
            const tooltips = document.querySelectorAll(".cx-productcard-promo-with-tooltip");
            for(let i = 0; i < tooltips.length; i++) {
              tooltips[i].addEventListener('click', (event) => {
                event.preventDefault();                       
              });
            }
          }

    });
})();

//Get the button
var mybutton = document.getElementById("myBtn");
function scrollFunction() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }

    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

 document.addEventListener("DOMContentLoaded", function () {
    console.log("⚡ Script running on DOMContentLoaded");
      // Re-get button after DOM loaded
    mybutton = document.getElementById("myBtn");
    
    // Check if button exists
    if (mybutton) {
        console.log("✅ Back to top button found");
        // Initial check
        scrollFunction();
    } else {
        console.log("❌ Back to top button not found");
    }
    const checkIframeAndStyle = () => {
      const iframe = document.getElementById("aioWriteAReview");

      if (!iframe) {
       // console.log("⏳ iframe#aioWriteAReview not found yet...");
        return;
      }

      let iframeDoc;
      try {
        iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      } catch (err) {
       // console.log("❌ Iframe not accessible yet");
        return;
      }

      if (iframeDoc && iframeDoc.readyState === "complete") {
        const heading = iframeDoc.querySelector("h3.rvw_heading");
        const btn = iframeDoc.querySelector(".egg-btns");

        if (heading) {
          heading.style.setProperty("display", "none", "important");
          console.log("✅ h3.rvw_heading hidden");
        }

        if (btn) {
          btn.style.setProperty("justify-content", "center", "important");
          console.log("✅ .egg-btns aligned center");
        }

        if (heading) {
          clearInterval(interval);
        } else {
          console.log("⏳ Elements not found inside iframe yet...");
        }
      }
    };

    const interval = setInterval(checkIframeAndStyle, 500);
    
  });
